<template>
  <div id="login" class="login-type-page">
    <img class="main-logo-mobile" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
    <main>
      <div class="msg-banner" v-if="passwordIsReset || passwordNotReset || invalidToken">
        <div v-if="passwordIsReset">
          <p class="text-success">{{ $t("login.password-reset") }}</p>
        </div>
        <div v-if="passwordNotReset || invalidToken">
          <p>
            <span class="text-danger"
              >{{ passwordNotReset ? $t("login.password-error") : $t("login.invalid-token") }}.
            </span>
            <router-link :to="{ name: 'forgot-password' }">{{$t('retry')}}</router-link>
          </p>
        </div>
      </div>
      <div class="content">
        <h2>Login</h2>
        <form id="loginForm" @submit.prevent="login">
          <custom-input
            id="emailInput"
            :inputType="'email'"
            v-model="loginModel.email"
            :name="'email'"
            :label="'Email'"
            :placeholder="$t('login.login-email-ph')"
            :focusInputField="true"
            boxed
          />

          <custom-input
            ref="passwordInput"
            id="passwordInput"
            :class="{ 'add-space': error == false }"
            :inputType="'password'"
            v-model="loginModel.password"
            :name="'password'"
            :label="'Password'"
            :placeholder="'**********'"
            boxed
          />

          <div class="small text-danger" v-if="error">
            {{ $t("login.login-error-1") }}<br />{{ $t("login.login-error-2") }}
          </div>
          <button class="btn-login btn-flex" type="submit" :disabled="loggingIn">
            <div v-show="loggingIn">
              <i class="search-icon fa-light fa-circle-notch fa-spin"></i>
            </div>
            {{ $t("login.login-btn") }}
          </button>

          <div class="to-password-reset">
            <router-link :to="{ name: 'forgot-password' }">{{$t('login.forgot-password-1')}}</router-link>
          </div>
        </form>

        <p class="to-signup-mobile">
          {{$t('login.sideview.signup-cta')}}
          <router-link :to="{ name: 'signup' }">{{ $t("login.to-signup2") }} </router-link>
        </p>
      </div>
    </main>

    <aside>
      <div class="content">
        <img class="main-logo" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
        <h1>{{$t('login.sideview.title')}}</h1>
        <h3>{{$t('login.sideview.sub-title')}}</h3>
        <p class="to-signup">
          {{$t('login.sideview.signup-cta')}}
          <router-link :to="{ name: 'signup' }">{{ $t("login.to-signup2") }} </router-link>
        </p>
      </div>
    </aside>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
export default {
  name: "login",
  data() {
    return {
      loginModel: {
        email: "",
        password: ""
      },
      error: false,
      loggingIn: false,
      passwordIsReset: false,
      passwordNotReset: false,
      invalidToken: false
    };
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      this.loggingIn = true;
      this.$store.dispatch("logIn", this.loginModel).then(
        () => {
          this.$router.push("home");
        },
        (error) => {
          this.error = true;
          this.loggingIn = false;
        }
      );
    }
  },
  mounted() {
    if (this.$store.token) this.$router.push("/");
  },
  created() {
    if (this.$route.query.passwordreset) {
      this.passwordIsReset = true;
    }
    if (this.$route.query.error) {
      this.passwordNotReset = true;
    }
    if (this.$route.query.invalidtoken) {
      this.invalidToken = true;
    }
    if (this.$route.query.signupFromDemo) {
      // Remove token and user state
      if (localStorage.token) {
        localStorage.removeItem("token");
      }
      this.$store.commit("resetUserState");

      this.$set(this.loginModel, "email", this.$route.query.signupFromDemo);
      this.$store.commit("setPostDemoGuide", true);
      this.$store.commit("setTemporaryLoginEmail", this.$route.query.signupFromDemo);
      this.$nextTick(() => {
        this.$refs.passwordInput.focus();
      });
    }
  },
  components: { CustomInput }
};
</script>

<style lang="less">
#login {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .main-logo-mobile {
    width: 180px;
    margin-bottom: 48px;
  }
  .main-logo {
    display: none;
  }

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    form {
      width: 300px;
      .btn-login {
        margin-top: 26px;
      }
    }
    .to-password-reset {
      font-size: 12px;
      text-align: center;
      margin: 36px 0 0 0;
    }
    a {
      color: var(--charcoal-50);
      text-decoration: underline;
    }
  }
  .to-signup-mobile {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    a {
      text-decoration: underline;
      color: var(--orange-web);
    }
  }
  aside {
    display: none;
  }
}


@media only screen and (min-width: 900px) {
  #login.login-type-page {
    h1 {
      margin-bottom: 32px;
      font-size: clamp(24px, 5vh, 46px);
    }
    h2 {
      font-size: 24px;
      margin: 0;
    }
    h3 {
      font-size: 18px;
    }

    .main-logo-mobile {
      display: none;
    }
    .main-logo {
      display: block;
    }
    .to-signup-mobile {
      display: none;
    }
  }

  #login {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    main {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .msg-banner {
        border-radius: var(--standard-border-radius);
        width: 400px;
        padding: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        background-color: #fff;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
        margin-bottom: 12px;
        p {
          color: #8f979c;
          margin: 0;
        }
      }
    }
    aside {
      height: 100vh;
      width: clamp(400px, 40vw, 550px);
      background: var(--signup-aside);
      padding: 0 20px 0 80px;
      box-shadow: inset 2px 0px 4px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .content{
        min-height: 300px;
      }
      h3 {
        margin-bottom: 12px;
      }
      .main-logo {
        margin-left: -8px;
        width: 180px;
      }
      .to-signup {
        font-size: 14px;
        font-weight: 500;
        a {
          text-decoration: underline;
        }
      }
    }
  }
}
@media only screen and (min-width: 1120px) {
  #login {
    main {
      form {
        width: clamp(400px, 12vw, 600px);
      }
    }
  }
}
</style>
